import React, { Component } from "react";
import { Link, NavLink } from "react-router-dom";
import { FaBars } from "react-icons/fa";
import logo from "../images/Logo.png";

export default class Navbar extends Component {
  state = {
    isOpen: false,
  };
  handleToggle = () => {
    this.setState({ isOpen: !this.state.isOpen });
  };
  render() {
    return (
      <nav className="navbar">
        <div className="nav-center">
          <div className="nav-logo">
            <Link to="/">
              <img src={logo} alt="logo" />
            </Link>
            <button
              type="button"
              className="nav-btn"
              onClick={this.handleToggle}
            >
              <FaBars className="nav-icon" />
            </button>
          </div>
          <ul
            className={this.state.isOpen ? "nav-links show-nav" : "nav-links"}
          >
            <li>
              <NavLink
                to="/"
                exact
                activeStyle={{
                  fontWeight: "bold",
                  color: "#9e2c3f",
                }}
              >
                Home
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/recipes"
                activeStyle={{
                  fontWeight: "bold",
                  color: "#9e2c3f",
                }}
              >
                Recipes
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/videos"
                activeStyle={{
                  fontWeight: "bold",
                  color: "#9e2c3f",
                }}
              >
                Videos
              </NavLink>
            </li>
          </ul>
        </div>
      </nav>
    );
  }
}
